import Transaction from "../../../classes/Transaction";
import { db } from "../../../boot/firebase";
import { collection, doc, writeBatch } from "firebase/firestore";

export const GET_TRANSACTION = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: Transaction,
    path: Transaction.getPath(id),
    stateKey: "transactions",
    id,
  });
};

export const GET_TRANSACTIONS = (
  { dispatch },
  { conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: Transaction,
    stateKey: "transactions",
    path: Transaction.getPath(),
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_TRANSACTION = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: Transaction,
    path: Transaction.getPath(id),
    stateKey: "transactions",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_TRANSACTIONS = (
  { dispatch },
  { listenerPath, conditions, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Transaction,
    path: Transaction.getPath(),
    stateKey: "transactions",
    listenerPath,
    conditions,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_TRANSACTION = async ({ dispatch, state }, tx) => {
  const batch = writeBatch(db);

  const saveDocuments = async (existingData) => {
    await dispatch("SAVE_DOCUMENTS", {
      batch,
      parentData: tx.data,
      fieldPath: "receipt",
      folderPath: tx.path,
      isSingle: true,
      existingData,
    });
    await dispatch("SAVE_DOCUMENTS", {
      batch,
      parentData: tx.data,
      fieldPath: "attachment",
      folderPath: tx.path,
      isSingle: true,
      existingData,
    });
  };

  // Handle bill payments
  let bill;
  if (tx.data.forType === "bill") {
    let [projectID, saleID, orderID, billID] = tx.data.for.split("-");
    bill = await dispatch("GET_BILL", {
      projectID,
      saleID,
      orderID,
      billID,
    });
  }

  if (!tx.data.created) {
    // New Transaction
    tx.data.created = new Date();
    tx.data.createdBy = state.user.id;

    const ref = doc(collection(db, Transaction.getPath())).withConverter(
      Transaction
    );
    tx.id = ref.id;

    await saveDocuments();
    batch.set(ref, tx);
  } else {
    // Existing Transaction
    tx.data.modified = new Date();
    tx.data.modifiedBy = state.user.id;
    const current = await dispatch("GET_TRANSACTION", tx.id);
    await saveDocuments(current.data);
    batch.set(doc(db, tx.path).withConverter(Transaction), tx);
  }

  if (bill) {
    await dispatch("UPDATE_SALE_STATUS", {
      batch,
      projectID: bill.projectID,
      saleID: bill.saleID,
      changes: {
        [`status.bills.${bill.id}.fullyPaid`]:
          bill.data.balance - tx.data.amount - tx.data.discount <= 0,
      },
    });
  }

  await batch.commit();
  return tx;
};

export const DELETE_TRANSACTION = async ({ dispatch }, id) => {
  const batch = writeBatch(db);

  const tx = await dispatch("GET_TRANSACTION", id);

  // Handle bill payment
  let bill;
  if (tx.data.forType === "bill") {
    let [projectID, saleID, orderID, billID] = tx.data.for.split("-");
    bill = await dispatch("GET_BILL", {
      projectID,
      saleID,
      orderID,
      billID,
    });
  }

  // Mark bill as unpaid
  if (bill) {
    await dispatch("UPDATE_SALE_STATUS", {
      batch,
      projectID: bill.projectID,
      saleID: bill.saleID,
      changes: {
        [`status.bills.${bill.id}.fullyPaid`]:
          bill.data.balance + tx.data.amount + tx.data.discount <= 0,
      },
    });
  }

  // Delete transaction
  batch.delete(doc(db, Transaction.getPath(id)));

  return batch.commit();
};
